// ============================================================================
// LanguageToggle — a compact segmented EN / 繁中 switch, in Pulse styling.
// Reads/writes the active locale via the i18n config; the whole tree re-renders
// through react-i18next on change.
// ============================================================================
import { useTranslation } from "react-i18next";
import { LOCALE_LABELS, SUPPORTED_LOCALES, setLocale } from "./config";
import type { Locale } from "./config";
import { cn } from "../lib/cn";

export function LanguageToggle({ className }: { className?: string }) {
  const { i18n, t } = useTranslation();
  const active = (i18n.language?.split("-")[0] ?? "en") as Locale;

  return (
    <div
      role="group"
      aria-label={t("common.language")}
      className={cn(
        "inline-flex items-center gap-1 rounded-pill bg-surface-sunken p-1 ring-1 ring-line",
        className,
      )}
    >
      {SUPPORTED_LOCALES.map((loc) => {
        const isActive = active === loc;
        return (
          <button
            key={loc}
            type="button"
            onClick={() => setLocale(loc)}
            aria-pressed={isActive}
            className={cn(
              "rounded-pill px-3 py-1 font-display text-xs font-bold transition-colors",
              isActive
                ? "bg-grad-coral text-white shadow-volt"
                : "text-body-soft hover:text-body",
            )}
          >
            {LOCALE_LABELS[loc]}
          </button>
        );
      })}
    </div>
  );
}
